module.exports = __webpack_public_path__ + "img/main.56447e71.png";